angular.
module("dx.webapp.routes").
directive("dxLiveRoster", function dxLiveRosterDirective($window, $timeout) {
	"use strict";

	return {
		restrict: "A",
		link: link,
	};

	function link($scope, $element) {
		var observer = null;
		var scheduled = null;
		var destroyed = false;
		var listening = false;

		if (typeof $window.ResizeObserver === "function") {
			try {
				observer = new $window.ResizeObserver(scheduleMeasurement);
				observer.observe($element[0]);
			} catch (error) {
				if (observer) {
					observer.disconnect();
					observer = null;
				}
			}
		}
		if (!observer) {
			$window.addEventListener("resize", scheduleMeasurement);
			listening = true;
		}

		scheduleMeasurement();
		$scope.$on("$destroy", onDestroy);

		function scheduleMeasurement() {
			if (destroyed || scheduled) {
				return;
			}
			scheduled = $timeout(measure, 0, false);
		}

		function measure() {
			scheduled = null;
			if (!destroyed) {
				var width = $element[0].clientWidth;
				var minimum = 1200;
				var extra = Math.max(0, width - minimum);
				var sharedExtra = 0.2 * extra;
				var style = $element[0].style;
				style.setProperty("--monitor-table-min-width", minimum + "px");
				style.setProperty("--monitor-student-width", (300 + 0.5 * extra) + "px");
				style.setProperty("--monitor-answer-width", (176 + 0.1 * extra) + "px");
				style.setProperty("--monitor-hand-in-width", (232 + sharedExtra) + "px");
				style.setProperty("--monitor-status-width", (220 + sharedExtra) + "px");
				$element.toggleClass("monitor-roster--pinned", width >= 960);
			}
		}

		function onDestroy() {
			destroyed = true;
			if (observer) {
				observer.disconnect();
			}
			if (listening) {
				$window.removeEventListener("resize", scheduleMeasurement);
			}
			if (scheduled) {
				$timeout.cancel(scheduled);
				scheduled = null;
			}
		}
	}
});
